


// Generated from io.spcfy.orders.samplemeta.enums.SequencingChemistry

export type SequencingChemistryKey =
  "MISEQ_V2_300" |
  "MISEQ_V2_500" |
  "MISEQ_V3_600" |
  "MINISEQ_MID_OUTPUT" |
  "MINISEQ_HIGH_OUTPUT" |
  "ISEQ_V1" |
  "ISEQ_V2" |
  "NEXTSEQ_550_MID_OUTPUT_V2" |
  "NEXTSEQ_550_HIGH_OUTPUT_V2" |
  "NEXTSEQ_P1" |
  "NEXTSEQ_P2" |
  "NEXTSEQ_P3" |
  "NEXTSEQ_P4" |
  "NOVASEQ_SP" |
  "NOVASEQ_S1" |
  "NOVASEQ_S2" |
  "NOVASEQ_S4" |
  "NOVASEQ_XLEAP_SBS" |
  "HISEQ_RAPID_V2" |
  "HISEQ_V4" |
  "TRUSEQ_V3_HS" |
  "TRUSEQ_RAPID" |
  "HISEQ_3000_4000_EXAMP";


export interface SequencingChemistryDTO {
  key: SequencingChemistryKey;
  label: string;
  group: string;    
}


export const SequencingChemistrys: Record<SequencingChemistryKey, SequencingChemistryDTO> = {
  MISEQ_V2_300: { key: "MISEQ_V2_300", label: "MiSeq Reagent Kit v2 – 300 cycles (2×150 bp)", group: "MiSeq Reagent Kits" },
  MISEQ_V2_500: { key: "MISEQ_V2_500", label: "MiSeq Reagent Kit v2 – 500 cycles (2×250 bp)", group: "MiSeq Reagent Kits" },
  MISEQ_V3_600: { key: "MISEQ_V3_600", label: "MiSeq Reagent Kit v3 – 600 cycles (2×300 bp)", group: "MiSeq Reagent Kits" },
  MINISEQ_MID_OUTPUT: { key: "MINISEQ_MID_OUTPUT", label: "MiniSeq Mid Output Kit – 2×150 bp", group: "MiniSeq Reagent Kits" },
  MINISEQ_HIGH_OUTPUT: { key: "MINISEQ_HIGH_OUTPUT", label: "MiniSeq High Output Kit – 2×150 bp or 2×300 bp (limited availability)", group: "MiniSeq Reagent Kits" },
  ISEQ_V1: { key: "ISEQ_V1", label: "iSeq 100 i1 Reagent Kit v1 – 2×150 bp (300 cycles)", group: "iSeq 100 Reagent Kits" },
  ISEQ_V2: { key: "ISEQ_V2", label: "iSeq 100 i1 Reagent Kit v2 – 2×150 bp (300 cycles)", group: "iSeq 100 Reagent Kits" },
  NEXTSEQ_550_MID_OUTPUT_V2: { key: "NEXTSEQ_550_MID_OUTPUT_V2", label: "NextSeq Mid Output Kit v2 – 2×75 bp or 2×150 bp (150–300 cycles)", group: "NextSeq 500/550 Reagent Kits" },
  NEXTSEQ_550_HIGH_OUTPUT_V2: { key: "NEXTSEQ_550_HIGH_OUTPUT_V2", label: "NextSeq High Output Kit v2 – 2×75 bp or 2×150 bp (150–300 cycles)", group: "NextSeq 500/550 Reagent Kits" },
  NEXTSEQ_P1: { key: "NEXTSEQ_P1", label: "P1 Reagent Kit – 100, 300, 600 cycles (up to 2×300 bp)", group: "NextSeq 1000/2000 Reagent Kits" },
  NEXTSEQ_P2: { key: "NEXTSEQ_P2", label: "P2 Reagent Kit – 100, 200, 300, 600 cycles", group: "NextSeq 1000/2000 Reagent Kits" },
  NEXTSEQ_P3: { key: "NEXTSEQ_P3", label: "P3 Reagent Kit – 100, 200, 300 cycles", group: "NextSeq 1000/2000 Reagent Kits" },
  NEXTSEQ_P4: { key: "NEXTSEQ_P4", label: "P4 Reagent Kit – 50, 100, 200, 300 cycles (NextSeq 2000 only)", group: "NextSeq 1000/2000 Reagent Kits" },
  NOVASEQ_SP: { key: "NOVASEQ_SP", label: "SP Kit v1.5 – 300 cycles (2×150 bp)", group: "NovaSeq 6000 Reagent Kits" },
  NOVASEQ_S1: { key: "NOVASEQ_S1", label: "S1 Reagent Kit – 200, 300 cycles", group: "NovaSeq 6000 Reagent Kits" },
  NOVASEQ_S2: { key: "NOVASEQ_S2", label: "S2 Reagent Kit – 200, 300 cycles", group: "NovaSeq 6000 Reagent Kits" },
  NOVASEQ_S4: { key: "NOVASEQ_S4", label: "S4 Reagent Kit – 200, 300 cycles", group: "NovaSeq 6000 Reagent Kits" },
  NOVASEQ_XLEAP_SBS: { key: "NOVASEQ_XLEAP_SBS", label: "XLEAP-SBS Reagent Kits – 100, 200, 300 cycles (2×50 to 2×150 bp)", group: "NovaSeq X Series (X / X Plus)" },
  HISEQ_RAPID_V2: { key: "HISEQ_RAPID_V2", label: "HiSeq Rapid SBS Kit v2 – 2×150 bp (300 cycles)", group: "HiSeq / Legacy Kits" },
  HISEQ_V4: { key: "HISEQ_V4", label: "HiSeq SBS Kit v4 – 2×125 bp (250 cycles)", group: "HiSeq / Legacy Kits" },
  TRUSEQ_V3_HS: { key: "TRUSEQ_V3_HS", label: "TruSeq SBS Kit v3-HS – 2×101 or 2×125 bp", group: "HiSeq / Legacy Kits" },
  TRUSEQ_RAPID: { key: "TRUSEQ_RAPID", label: "TruSeq Rapid SBS Kit – 2×50 or 2×150 bp", group: "HiSeq / Legacy Kits" },
  HISEQ_3000_4000_EXAMP: { key: "HISEQ_3000_4000_EXAMP", label: "HiSeq 3000/4000 SBS Kit (ExAmp) – 2×150 bp", group: "HiSeq / Legacy Kits" }
};
